import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { TagsTabPageView } from './TagsTabPageView';

export function TagsTabPageContainer() {
  const { orgId } = useParams<{ orgId: string }>();
  const { t } = useTranslation('organization');

  return <TagsTabPageView title={t('tags.title', { orgId })} />;
}
